import MeetingEdit from "./edit"
import MeetingView from "./view"

export default { view: MeetingView, edit: MeetingEdit }
